import { getCourseFiles } from "../../DriveScout/API/models/CourseModel";

const emptyViewingCourse = () => ({
  id: 0,
  class_id: 0,
  date: null,
  start: null,
  end: null,
  instructor: {},
  instructor_id: 0,
});

// Returned to any screen asking about a course other than the one currently pinned.
const NO_VIEWING_CLASS = Object.freeze(emptyViewingCourse());

const state = {
  viewingCourse: emptyViewingCourse(),
};

const mutations = {
  SET_VIEW_COURSE(state, course) {
    state.viewingCourse.id = course.id;
    state.viewingCourse.class_id = course.class_id;
    state.viewingCourse.date = course.date;
    state.viewingCourse.start = course.start;
    state.viewingCourse.end = course.end;
    state.viewingCourse.instructor = course.instructor;
    state.viewingCourse.instructor_id = course.instructor_id;
  },
};

const actions = {
  SET_VIEW_COURSE({ commit }, course) {
    commit("SET_VIEW_COURSE", course);
  },
  GET_COURSE_FILES({ commit }, id) {
    return getCourseFiles(id).then((response) => {
      return response.files;
    });
  },
};

const getters = {
  viewingCourse: (state) => state.viewingCourse,
  // viewingCourse is a single "last viewed" slot shared by every course screen and it
  // is never reset on navigation, so a class pinned while viewing one course would
  // otherwise be read - and sent back up - by a screen showing a different course.
  // These two getters make the slot unreadable without naming the course it belongs to.
  // Ids are coerced because callers pass them from route params and calendar events,
  // which deliver strings, as well as from API payloads, which deliver numbers.
  viewingClassForCourse: (state) => (courseId) =>
    Number(state.viewingCourse.id) === Number(courseId)
      ? state.viewingCourse
      : NO_VIEWING_CLASS,
  // 0 is the established "no class selected" sentinel.
  classIdForCourse: (state, getters) => (courseId) =>
    Number(getters.viewingClassForCourse(courseId).class_id) || 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
